/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Injectable} from '@angular/core';
import {VerticalNavGroup} from '../vertical-nav-group';
export class VerticalNavGroupRegistrationService {
public navGroupCount: number = 0;
/**
 * @return {?}
 */
registerNavGroup() {
        this.navGroupCount++;
    }
/**
 * @return {?}
 */
unregisterNavGroup(): void {
        this.navGroupCount--;
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function VerticalNavGroupRegistrationService_tsickle_Closure_declarations() {
/** @type {?} */
VerticalNavGroupRegistrationService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
VerticalNavGroupRegistrationService.ctorParameters;
/** @type {?} */
VerticalNavGroupRegistrationService.prototype.navGroupCount;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
